import styled from 'styled-components';

export const MobileAppFirstStartContentStyled = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 16px;

    @media (max-height: 700px) {
        & > img {
            max-width: 300px;
        }
    }
`;

export const MobileAppFirstStartButtonsContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 86px;
    margin-bottom: 48px;
`;
